import type { InitialState } from './types';

export const MAX_RESULTS = 1;

export const HERO_IMAGE_PROVIDER_INITIAL_STATE: InitialState = {
  error: null,
  isLoading: false,
  url: null,
};
